import { createSlice } from "@reduxjs/toolkit";

export const tokenSlice = createSlice({
  name: "token",
  initialState: {
    isTokenExpired: false,
  },
  reducers: {
    updateTokenExpiryStatus: (state, action) => {
      state.isTokenExpired = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateTokenExpiryStatus } = tokenSlice.actions;

export default tokenSlice.reducer;
